// Query Keys helper – colocated with feature API
import { TAB_DEFAULT_BASE_NAME } from '@/features/Dashboard/constants/names';
import {
  normalizeDashboardTabs,
  normalizeTabEntry,
  processMarketApps
} from '@/features/Dashboard/lib/transformers';
import type { DashboardResponse, DashboardTab } from '@/features/Dashboard/types';
import { generateUniqueUUID } from '@/utils/generateUniqueUUID';

export const dashboardQueryKeys = {
  all: ['dashboard'] as const,
  shared: (token: string) => ['shared-dashboard', token] as const
};
/**
 * Normalizes a raw dashboard response (single dashboard) into a DashboardTab.
 * Reused by both useDashboard and useSharedDashboard.
 */
export const normalizeDashboardEntry = (name: string, value: DashboardResponse): DashboardTab => {
  const dashboardTabs: DashboardTab =
    normalizeDashboardTabs(value, name, name) ??
    ({
      [TAB_DEFAULT_BASE_NAME]: { id: generateUniqueUUID(new Set()), content: [] }
    } as DashboardTab);

  return Object.fromEntries(
    Object.entries(dashboardTabs).map(([tabName, tabValue]) => {
      const tabEntry = normalizeTabEntry(tabName, tabValue);
      return [
        tabName,
        {
          ...tabEntry,
          content: processMarketApps(tabEntry.content)
        }
      ];
    })
  );
};
